import { useEffect, useState } from 'react';
import { viewportFor } from './Level.jsx';
import { FLOOR_H, STANDS_AT } from './level.js';
import { SCENE } from './palette.js';
import { sizedSprite } from './print.jsx';
import { useSeason } from './seasons/index.js';
import { FLOOR_TILE, READER, WALL_TILE } from './sprites.js';

// What the level shows while the books are on their way: the room before
// anything has been put in it. The same wall, the same floor, at the same
// scale, with the reader walking on the spot under NOW LOADING - so when the
// shelves arrive the bookcases appear in a room that was already there,
// rather than a game cutting in over a web page's spinner.
//
// Everything in it is already in the bundle - sprites are data URIs - so it
// costs no request and is on the screen in the frame the theme is known.
// It does not use the stage and its one transform the way the level does;
// there is nothing here to scroll, so each piece is drawn at the level's own
// whole-number scale instead, which lands every pixel where the level's would.

const scaleNow = () => viewportFor(window.innerWidth, window.innerHeight).scale;

export default function Loading() {
  const season = useSeason();
  const cast = season?.reader || READER;
  const [scale, setScale] = useState(scaleNow);

  useEffect(() => {
    const measure = () => setScale(scaleNow());
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  const tile = (sprite) => ({
    backgroundImage: sprite.url,
    backgroundSize: `${sprite.width * scale}px ${sprite.height * scale}px`,
  });

  return (
    <div
      className="eb eb-loading"
      role="status"
      aria-label="Loading"
      data-season={season?.id}
      style={{ backgroundColor: SCENE.wallDark, ...tile(WALL_TILE) }}
    >
      <p className="eb-loading-text" style={{ fontSize: `${8 * scale}px`, lineHeight: `${8 * scale}px` }}>
        NOW LOADING
        <span className="eb-loading-dots" aria-hidden="true"><span>...</span></span>
      </p>
      <div className="eb-loading-floor" style={{ height: `${FLOOR_H * scale}px`, ...tile(FLOOR_TILE) }} />
      {/* One element swapping between the two frames of the walk. It was two
          elements taking turns, and two animations meeting at a boundary
          could both be showing for a frame - the two drawings on top of each
          other. */}
      <i
        className="eb-loading-reader"
        style={{
          bottom: `${STANDS_AT * scale}px`,
          ...sizedSprite(cast.step1, scale),
          '--eb-step-a': cast.step1.url,
          '--eb-step-b': cast.step2.url,
        }}
      />
    </div>
  );
}
